import React from 'react';
import { downloadTextFile } from '../utils/csvUtils';

export function NotificationBanners({
    error,
    refresh,
    exportError,
    onExportResultsCsv,
    selectedDeploymentId,
    setExportError,
    loading,
    corsBanner,
    isOnline,
}) {
    return (
        <>
            {error && (
                <div data-cy="error-banner" style={{ position: 'fixed', bottom: 10, left: 10, background: '#FFEBEE', border: '1px solid #FFCDD2', padding: '6px 10px', borderRadius: 6, color: '#C62828', display: 'flex', gap: 8, alignItems: 'center' }}>
                    <span>{error}</span>
                    <button onClick={() => refresh()}>Retry</button>
                </div>
            )}
            {exportError && (
                <div data-cy="export-error" style={{ position: 'fixed', bottom: 42, left: 10, background: '#FFF8E1', border: '1px solid #FFE0B2', padding: '8px 10px', borderRadius: 6, color: '#E65100', display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span>{exportError.message}</span>
                    <button onClick={() => onExportResultsCsv()} style={{ marginLeft: 6 }}>Retry</button>
                    <button onClick={() => onExportResultsCsv({ extended: true })}>Extended Retry</button>
                    {exportError.rawText && (
                        <button onClick={() => downloadTextFile(exportError.rawText, `raw_${selectedDeploymentId || 'results'}.csv`, 'text/plain;charset=utf-8')}>Download Raw</button>
                    )}
                    <button onClick={() => setExportError(null)} style={{ marginLeft: 6 }}>Dismiss</button>
                </div>
            )}
            {loading && (
                <div style={{ position: 'fixed', bottom: 10, right: 10, background: '#E3F2FD', border: '1px solid #BBDEFB', padding: '6px 10px', borderRadius: 6, color: '#1565C0' }}>Loading…</div>
            )}
            {corsBanner && (
                <div data-cy="cors-banner" style={{ position: 'fixed', bottom: 46, right: 10, background: '#FFF8E1', border: '1px solid #FFE0B2', padding: '6px 10px', borderRadius: 6, color: '#E65100' }}>{corsBanner}</div>
            )}
            {!isOnline && (
                <div data-cy="connectivity-banner" style={{ position: 'fixed', bottom: 78, right: 10, background: 'var(--color-bg-base)', border: '1px solid #DADCE0', padding: '6px 10px', borderRadius: 6, color: '#5F6368' }}>Offline – changes will retry when connection is restored</div>
            )}
        </>
    );
}
